import { NestedSegmentDefinitionInput, SegmentDefinition } from 'domains/segments/types';

/**
 * Builds the preview-count payload that scopes an exit criteria to a campaign's starting audience.
 *
 * The raw exit-count preview counts matches across the entire contact universe, which is misleading
 * for a campaign that only targets a small entry audience (e.g. "~35,739 match" when 4 contacts are
 * enrolled). ANDing the starting-audience definition with the exit definition — as two subsegments of
 * an AND group — yields the count of starting-audience contacts that would exit, which is the number
 * the author actually cares about.
 *
 * Only meaningful for plain-segment entry audiences; callers must omit it for cohort / A-B / continual
 * campaigns where a starting-audience definition isn't available (the count is hidden in those cases).
 */
export const buildScopedExitCountDefinition = (
    startingAudienceDefinition: SegmentDefinition,
    exitDefinition: SegmentDefinition
): NestedSegmentDefinitionInput => ({
    matchType: 'AND',
    demographic: [],
    engagement: [],
    contactEvent: [],
    contactObject: [],
    subsegments: [startingAudienceDefinition, exitDefinition],
});
